import CommonSelector from "@lhd/components/CommonSelector";
import { ICommonFieldProps } from "../../../../interfaces";

const SelectEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange, colDef } = props;

  return (
    <CommonSelector
      defaultValue={defaultValue ?? undefined}
      options={colDef.options ?? []}
      height="calc(100% - var(--cell-vertical-spacing))"
      showSearch
      optionFilterProp="label"
      allowClear
      onChange={(value) => onChange?.(value ?? "")}
    />
  );
};

export default SelectEditCell;
